import { call, put, takeLatest, all } from "redux-saga/effects"
import {
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_MEASURE_INFO_WATCHER,
  GET_MEASURE_TOTAL_SUB_DIVISION_WATCHER,
  GET_MEASURE_TOTAL_WATCHER,
  GET_STATUS_WATCHER,
} from "./constants"

import {
  getMeasureColorRangeFailed,
  getMeasureColorRangeSuccess,
  getMeasureInfoSuccess,
  getMeasureTotalFailed,
  getMeasureTotalSubDivisionFailed,
  getMeasureTotalSubDivisionSuccess,
  getMeasureTotalSuccess,
  getStatusFailed,
  getStatusSuccess,
} from "./actions"
import {
  KEY_CHECKBOX_EXCLUDE,
  KEY_ISOLATED_METRICS,
  LOCAL_TOKEN,
  setItem,
} from "../../../utils/storage"
import {
  getDivisionsAvailableApi,
  getMeasureColorRangeApi,
  getMeasureReportApi,
  getMeasureTotalReportApi,
} from "../../../utils/routes/routes-report"
import { validate } from "../../../utils/functions"
import axios from "axios"

function getReportMeasureInfoApi(params) {
  const paramSegment = validate.empty(params.id_segment)
    ? ""
    : `&id_segment=${params.id_segment}`
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params.idMeasure}/info?f${paramSegment}`,
  })
}

export function* getStatusSaga(action) {
  try {
    const dataStatus = action.payload

    const [
      { data: resultMeasure },
      { data: resultTotal, user_type: userType },
    ] = yield all([
      call(getMeasureReportApi, dataStatus.params),
      call(getMeasureTotalReportApi, dataStatus.params),
    ])
    let divisions = null
    let divisionSelected = dataStatus.params.id_divisionParent
      ? dataStatus.params.id_divisionParent
      : userType.select_division

    if (resultTotal) {
      if (
        !validate.exist(dataStatus.params.id_divisionParent) &&
        validate.exist(divisionSelected)
      ) {
        action.payload.history.push(
          `${action.payload.history.location.pathname}?id_divisionParent=${divisionSelected}`
        )
      }
      const dataParams = {
        excludeParam: dataStatus.params.isExclude
          ? "&exclude=true"
          : "&exclude=false",
        id_measure: dataStatus.params.id_measure,
        id_division: divisionSelected,
      }
      const data = yield call(getDivisionsAvailableApi, dataParams)

      let divisionsAvailable = data.data

      divisions = divisionsAvailable.filter(
        (row) => row.id_division !== divisionSelected
      )
      const divisionAux = divisionsAvailable.find(
        (row) => row.id_division === divisionSelected
      )
      if (divisionAux) {
        userType.divisions.map((row) => {
          if (divisionSelected === row.id_division) {
            row.employees = divisionAux.employees
          }
          return row
        })
      }

      if (!resultMeasure.has_isolated_metrics) {
        setItem(KEY_CHECKBOX_EXCLUDE, false)
        setItem(KEY_ISOLATED_METRICS, false)
      }

      yield put(
        getStatusSuccess({
          measureGeneral: resultMeasure,
          measureTotal: resultTotal,
          divisionsAvailable: divisions,
          divisionsData: data,
          userType,
        })
      )
    }
  } catch (error) {
    console.log(error)
    yield put(getStatusFailed())
    if (error.response && error.response.status === 404) {
      action.payload.history.push("/error")
    } else if (error.response && error.response.status === 401) {
      action.payload.history.push("/login")
    }
  }
}

export function* getMeasureColorRangeSaga(action) {
  try {
    const response = yield call(getMeasureColorRangeApi, action.payload)
    yield put(getMeasureColorRangeSuccess(response.data))
  } catch (e) {
    yield put(getMeasureColorRangeFailed())
  }
}

export function* getMeasureTotalSaga(action) {
  try {
    const dataStatus = action.payload
    const { data: resultTotal, user_type: userType } = yield call(
      getMeasureTotalReportApi,
      dataStatus.params
    )
    const dataParams = {
      excludeParam: dataStatus.params.isExclude
        ? "&exclude=true"
        : "&exclude=false",
      id_measure: dataStatus.params.id_measure,
      id_division: dataStatus.params.id_division,
      ...(dataStatus.params.id_segment && { id_segment: dataStatus.params.id_segment }),
    }
    let divisions = null
    let divisionSelected = dataStatus.params.id_division
      ? dataStatus.params.id_division
      : userType.select_division

    if (resultTotal) {
      const { data: divisionsAvailable } = yield call(
        getDivisionsAvailableApi,
        dataParams
      )
      divisions = divisionsAvailable.filter(
        (row) => row.id_division !== divisionSelected
      )
      const divisionAux = divisionsAvailable.find(
        (row) => row.id_division === divisionSelected
      )
      if (divisionAux) {
        userType.divisions.map((row) => {
          if (divisionSelected === row.id_division) {
            row.employees = divisionAux.employees
          }
          return row
        })
      }
    }
    yield put(
      getMeasureTotalSuccess({
        measureTotal: resultTotal,
        userType,
        divisionsAvailable: divisions,
      })
    )
  } catch (e) {
    yield put(getMeasureTotalFailed())
  }
}

export function* getMeasureTotalSubDivisionSaga(action) {
  try {
    const dataStatus = action.payload
    const { data: resultTotal, user_type: userType } = yield call(
      getMeasureTotalReportApi,
      dataStatus.params
    )
    yield put(getMeasureTotalSubDivisionSuccess({ resultTotal, userType }))
  } catch (e) {
    yield put(getMeasureTotalSubDivisionFailed())
  }
}

export function* getMeasureInfoSaga(action) {
  try {
    const { data: measureInfo } = yield call(
      getReportMeasureInfoApi,
      action.payload
    )
    yield put(getMeasureInfoSuccess({ measureInfo: measureInfo.data }))
  } catch (e) {
    // no-op: measureInfo is supplemental, failure is non-fatal
  }
}

export default function* reportAmbassadorV2Saga() {
  yield takeLatest(GET_STATUS_WATCHER, getStatusSaga)
  yield takeLatest(GET_MEASURE_COLOR_RANGE_WATCHER, getMeasureColorRangeSaga)
  yield takeLatest(GET_MEASURE_TOTAL_WATCHER, getMeasureTotalSaga)
  yield takeLatest(
    GET_MEASURE_TOTAL_SUB_DIVISION_WATCHER,
    getMeasureTotalSubDivisionSaga
  )
  yield takeLatest(GET_MEASURE_INFO_WATCHER, getMeasureInfoSaga)
}
